// extracted by mini-css-extract-plugin
export default {"container":"product-card_container__RFk-9","priceBox":"product-card_priceBox__V9oXO"};